import { defineComponent as _defineComponent } from 'vue'
import ShokurekishoJobProjectListPanel from '@/components/format-edit/shokurekisho/ShokurekishoJobProjectListPanel.vue'
import { useHistoryItemDescResize } from '@/composables/format-edit/useShokurekishoHistoryItem'
import type { ShokurekishoProjectItem } from '@/composables/format-edit/useShokurekishoFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoCareerJobProjectEditPanel',
  props: {
    projects: null,
    isActive: { type: Boolean },
    minYear: null,
    maxYear: null
  },
  emits: ["add-project", "delete-job", "ok", "move-up", "move-down", "delete-item"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'add-project'): void
  (e: 'delete-job'): void
  (e: 'ok'): void
  (e: 'move-up', index: number): void
  (e: 'move-down', index: number): void
  (e: 'delete-item', index: number): void
}), expose: any, slots: any, attrs: any }) {





const { desc } = useHistoryItemDescResize()

return { __sfc: true,emit, desc, ShokurekishoJobProjectListPanel }
}

})